/* esm.sh - applesauce-signers@5.2.0/signers/extension-signer */
export * from "/*applesauce-signers@5.2.0/esnext/signers/extension-signer.mjs";
